import { useMemo } from 'react'
import { Box, Typography } from '@mui/material'
import EmrSubSectionsHandler from 'src/mentor/components/EmrRelatedComponents/components/EmrSubSectionsHandler'
import EmrSectionActionsGroup from 'src/mentor/components/EmrRelatedComponents/components/EmrSectionActionsGroup'

export default function EmrSectionDataHandler({
  emrSection,
  emrSectionDataList,
  setEmrSectionDataList,
  excludeSubSectionIds = [],
  practitionerRole, // NEW: For role-based action filtering (ROLE_DOCTOR, ROLE_SCREENER, etc.)
  runtime, // NEW: Runtime context for action path templating
  hideHeading = false,
}) {
  const emrSectionResponse = emrSection?.emrSectionResponse
  const mainSection = emrSectionResponse?.section
  // console.log({ mainSection, emrSectionResponse }) // Removed to prevent loop logging
  const subSections = mainSection?.subSections
  const sectionLevelActions = mainSection?.actions || [] // NEW: Section-level actions
  const currentEmrSectionData = useMemo(() => {
    const sectionCode = mainSection?.defCode
    const emrData = emrSectionDataList?.find(
      (sectionData) => sectionData?.sectionCode === sectionCode,
    )
    return emrData
  }, [mainSection, emrSectionDataList])

  const finalSubSections = subSections?.filter((sSectn) => {
    if (excludeSubSectionIds.includes(sSectn?.uid)) {
      return false
    }
    return true
  })

  function handleSetCurrentSectionData(sectionPrev) {
    setEmrSectionDataList((prevList) => {
      const sectionCode = mainSection?.defCode
      let updatedSectionData
      if (typeof sectionPrev === 'function') {
        let currentSectionData = prevList?.find(
          (sectionData) => sectionData?.sectionCode === sectionCode,
        )
        if (!currentSectionData) {
          currentSectionData = {
            sectionCode: mainSection?.defCode,
            sectionVersionUsed: mainSection?.defVersion,
            subSections: [],
          }
        }

        updatedSectionData = sectionPrev(currentSectionData)
      } else {
        updatedSectionData = {
          sectionCode: mainSection?.defCode,
          sectionVersionUsed: mainSection?.defVersion,
          subSections: [],
          ...sectionPrev,
        }
      }

      const doesSectionAlreadyExist = prevList.some(
        (sectionData) => sectionData?.sectionCode === sectionCode,
      )
      if (doesSectionAlreadyExist) {
        return prevList.map((sectionData) =>
          sectionData?.sectionCode === sectionCode ? updatedSectionData : sectionData,
        )
      } else {
        return [...(prevList || []), updatedSectionData]
      }
    })
  }

  function handleSetSubSections(subSectionPrev) {
    if (typeof subSectionPrev === 'function') {
      handleSetCurrentSectionData((prev) => {
        return {
          ...(prev || {}),
          subSections: subSectionPrev(prev?.subSections || []),
        }
      })
    } else {
      handleSetCurrentSectionData((prev) => ({
        ...(prev || {}),
        subSections: subSectionPrev,
      }))
    }
  }

  return (
    <Box sx={{ background: '#fff', border: '1px solid #ddd', borderRadius: 2, p: 2, mb: 2 }}>
      {/* Section header with title and actions */}
      {(mainSection?.title || sectionLevelActions?.length > 0) && !hideHeading && (
        <>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              borderRadius: 1,
            }}
          >
            {mainSection?.title && <h4 className='m-0'>{mainSection.title}</h4>}

            {/* Section-level actions */}
            <EmrSectionActionsGroup
              actions={sectionLevelActions}
              scope="section"
              context={{
                sectionData: currentEmrSectionData,
              }}
              practitionerRole={practitionerRole}
              runtime={runtime}
              sectionData={currentEmrSectionData}
              setSectionData={handleSetCurrentSectionData}
            />
          </Box>
          <hr />
        </>
      )}

      {/* Subsections */}
      <EmrSubSectionsHandler
        subSections={finalSubSections}
        layout="grid"
        columns={3}
        spacing={2}
        subSectionsDataList={currentEmrSectionData?.subSections}
        setSubSectionsDataList={handleSetSubSections}
        sectionLevelActions={sectionLevelActions}
        practitionerRole={practitionerRole}
        runtime={runtime}
      />
    </Box>
  )
}
